export enum Browser {
  Chrome = 'Chrome',
  Edge = 'Edge',
  Firefox = 'Firefox',
  IE = 'Internet Explorer',
  Safari = 'Safari'
}
